import React from "react";
import Chat from "./Chat";
import { Message } from "./ChatWindow";
import Navbar from "../Layout/Navbar";
import EmptyChat from "./EmptyChat";
import { useSession } from "../../context/SessionContext";

interface ChatLayoutProps {
  messages: Message[];
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  isExpanded: boolean;
  loading: boolean;
  analyzing: boolean; // New prop for analyzing state
  browsing: boolean;
  sendMessage: (message: string, uploadedFiles?: File[], connector?: string, quotedText?: string, quotedMessageId?: string) => Promise<void>;
  handleMic: () => Promise<void>;
  isRecording: boolean;
  isSpeaking: boolean;
  stopMessageStream: () => void;
  messageAppeared: boolean;
  rewrite: (message_id: string) => void;
  focusMode: string;
  setFocusMode: React.Dispatch<React.SetStateAction<string>>;
  createVirtualAssistant: () => void;
  clientLogoUrl: string | null;
  logoLoading: boolean;
  logoError: boolean;
  fullConversationAudioUrl: string | null;
}

const ChatLayout: React.FC<ChatLayoutProps> = ({
  messages,
  setIsExpanded,
  isExpanded,
  loading,
  analyzing, // Accept analyzing state as a prop
  browsing,
  sendMessage,
  handleMic,
  isRecording,
  isSpeaking,
  stopMessageStream,
  messageAppeared,
  rewrite,
  focusMode,
  setFocusMode,
  createVirtualAssistant,
  clientLogoUrl,
  logoLoading,
  logoError,
  fullConversationAudioUrl,

}) => {
  const { loadingConversation } = useSession();

  // NEW: Quote state
  const [quotedText, setQuotedText] = React.useState<string | null>(null);
  const [sourceMessageId, setSourceMessageId] = React.useState<string | null>(null);

  const handleQuote = (text: string, messageId: string) => {
    setQuotedText(text);
    setSourceMessageId(messageId);
  };

  const clearQuote = () => {
    setQuotedText(null);
    setSourceMessageId(null);
  };

  return (
    <div className="flex flex-col h-screen w-full relative bg-surface text-primary">
      <Navbar
        messages={messages}
        setIsExpanded={setIsExpanded}
        isExpanded={isExpanded}
      />
      <div className="flex-1 overflow-hidden w-full">
        {messages.length > 0 ? (
          <Chat
            loading={loading}
            analyzing={analyzing}
            browsing={browsing}
            messages={messages}
            sendMessage={sendMessage}
            handleMic={handleMic}
            isRecording={isRecording}
            isSpeaking={isSpeaking}
            stopMessageStream={stopMessageStream}
            messageAppeared={messageAppeared}
            rewrite={rewrite}
            createVirtualAssistant={createVirtualAssistant}
            clientLogoUrl={clientLogoUrl}
            logoLoading={logoLoading}
            logoError={logoError}
            fullConversationAudioUrl={fullConversationAudioUrl}
            quotedText={quotedText}
            sourceMessageId={sourceMessageId}
            handleQuote={handleQuote}
            clearQuote={clearQuote}
          />
        ) : (
          <EmptyChat
            sendMessage={sendMessage}
            handleMic={handleMic}
            isRecording={isRecording}
            isSpeaking={isSpeaking}
            focusMode={focusMode}
            setFocusMode={setFocusMode}


            // Pass quote props for consistency, though EmptyChat might not strictly need selection on itself
            // If EmptyChat needs to send a message with a quote (unlikely from empty state, but good for types)
            quotedText={quotedText}
            sourceMessageId={sourceMessageId}
            clearQuote={clearQuote}
          />
        )}
      </div>
    </div>
  );
};

export default ChatLayout;
